module.exports = __webpack_public_path__ + "static/img/member-area3.403c23c0.png";